<div class="desktop:pl-54 flex min-h-screen pl-0 transition-all duration-300" id="layout-sidebar">
	@if(isNavbarOpen) {
	<button
		class="desktop:hidden bg-surface-950/40 fixed inset-0 z-20 block cursor-pointer"
		tabindex="0"
		animate.enter="fade-in"
		animate.leave="fade-out"
		(click)="closeNavbar()"
		(keydown.enter)="closeNavbar()"
		(keydown.space)="closeNavbar(); $event.preventDefault()"
	></button>
	}
	<div
		class="desktop:translate-x-0 fixed top-0 bottom-0 left-0 z-20 w-54 -translate-x-full transition-all duration-300"
		[ngClass]="{'translate-x-0':isNavbarOpen}"
		id="sidebar-wrapper"
	>
		<app-layout-sidebar-navbar></app-layout-sidebar-navbar>
	</div>
	<main class="bg-surface-50 desktop:pt-0 grow overflow-x-hidden pt-16">
		<div class="desktop:hidden fixed top-0 right-0 left-0 z-10">
			<app-layout-sidebar-header (menu)="openNavbar()"></app-layout-sidebar-header>
		</div>
		<router-outlet></router-outlet>
	</main>
	<p-confirmdialog />
	<p-toast></p-toast>
</div>
